// MigrateRostrosDialog.styles.js

export const dialogPaper = {
  borderRadius: "16px",
}

export const dialogTitle = {
  background: "linear-gradient(135deg, #092147 0%, #1e3a8a 100%)",
  color: "white",
  borderRadius: "16px 16px 0 0",
  padding: "20px 24px",
}

export const titleBox = {
  display: "flex",
  alignItems: "center",
  gap: "12px",
}

export const stepperBox = {
  padding: "16px 24px 0",
  backgroundColor: "#f8fafc",
}

export const contentPadding = {
  padding: "24px",
}

export const deviceCard = active => ({
  borderRadius: "12px",
  border: `2px solid ${active ? "#092147" : "#e0e0e0"}`,
  background: active
    ? "linear-gradient(135deg, #f0f4ff 0%, #e8efff 100%)"
    : "#fafafa",
  padding: "16px",
  transition: "all 0.2s ease",
})

export const deviceCardHeader = {
  display: "flex",
  alignItems: "center",
  gap: "10px",
  marginBottom: "8px",
}

export const deviceAvatar = active => ({
  width: 40,
  height: 40,
  backgroundColor: active ? "#092147" : "#9e9e9e",
})

export const deviceName = {
  fontWeight: 700,
  fontSize: "0.95rem",
  color: "#2c3e50",
  lineHeight: 1.2,
}

export const deviceIp = {
  fontFamily: "monospace",
  fontSize: "0.75rem",
  backgroundColor: "#f1f5f9",
  padding: "2px 6px",
  borderRadius: "4px",
  color: "#64748b",
}

export const arrowBox = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "8px",
}

export const arrowIcon = {
  fontSize: 36,
  color: "#092147",
}

export const sectionLabel = {
  fontSize: "0.75rem",
  fontWeight: 700,
  color: "#64748b",
  textTransform: "uppercase",
  letterSpacing: "0.08em",
  marginBottom: "8px",
}

export const rostroListItem = synced => ({
  display: "flex",
  alignItems: "center",
  gap: "12px",
  padding: "10px 12px",
  borderRadius: "8px",
  border: "1px solid #e0e0e0",
  backgroundColor: synced ? "#f0fdf4" : "#fff",
  marginBottom: "6px",
})

export const rostroAvatar = {
  width: 44,
  height: 44,
  borderRadius: "8px",
  objectFit: "cover",
  border: "1px solid #e0e0e0",
}

export const rostroAvatarPlaceholder = {
  width: 44,
  height: 44,
  borderRadius: "8px",
  backgroundColor: "#e2e8f0",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}

export const progressBox = {
  textAlign: "center",
  padding: "32px 24px",
}

export const progressBarBox = {
  margin: "16px 0",
}

export const resultsSummary = success => ({
  borderRadius: "12px",
  padding: "16px 20px",
  marginBottom: "16px",
  backgroundColor: success ? "#f0fdf4" : "#fff7ed",
  border: `1px solid ${success ? "#86efac" : "#fdba74"}`,
  display: "flex",
  alignItems: "center",
  gap: "12px",
})

export const warningBox = {
  backgroundColor: "#fff3e0",
  border: "1px solid #ffcc02",
  borderRadius: "10px",
  padding: "12px 16px",
  marginTop: "16px",
}

export const dialogActions = {
  padding: "16px 24px",
  borderTop: "1px solid #e0e0e0",
  gap: "8px",
}

export const migrateButton = {
  backgroundColor: "#092147",
  color: "white",
  borderRadius: "8px",
  textTransform: "none",
  fontWeight: 700,
  padding: "8px 24px",
}

export const cancelButton = {
  borderRadius: "8px",
  textTransform: "none",
}

export const searchBox = {
  marginBottom: "12px",
}

export const countChip = count => ({
  backgroundColor: count > 0 ? "#e8f5e9" : "#fce4ec",
  color: count > 0 ? "#2e7d32" : "#c62828",
  fontWeight: 700,
  fontSize: "0.8rem",
})

export const emptyState = {
  textAlign: "center",
  padding: "32px",
  color: "#9e9e9e",
}
